var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#020002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.375a9.625 9.625 0 1 0 0 19.25 9.625 9.625 0 0 0 0-19.25zm0 17.875a8.25 8.25 0 1 1 0-16.5 8.25 8.25 0 0 1 0 16.5z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.188a1.031 1.031 0 1 0 0-2.063 1.031 1.031 0 0 0 0 2.063zM15.688 8.5h-1.032a3.086 3.086 0 0 0-3.094 3.094v.344h1.376v-.344a1.719 1.719 0 0 1 1.718-1.719h1.031a1.719 1.719 0 0 1 0 3.438h-1.374v3.093h1.374v-1.718a3.094 3.094 0 1 0 0-6.188z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.5cb94e25c1cdbd5391eecdd7c21127aa.svg";
export { ForwardRef as ReactComponent };